export const RULE_BUILDER_VERSION = '1.0.0';
